import React, { useState, useContext, useEffect } from 'react';
import { Box, Divider, List, ListItem, ListItemIcon, ListItemText, Typography, Button, Chip } from '@mui/material';
import FormBox from './building_blocks/FormBox';
import ProviderCard from './building_blocks/ProviderCard';
import SearchField from './SearchField';
import { providersPathTo } from '../utils/Api';
import { SearchContext } from '../contexts/SearchContext';
import { useNavigate } from 'react-router-dom';
/*Icons*/
import { ArrowBackRounded } from '@mui/icons-material';

const Search = () => {
  const [loading, setLoading] = useState(false);
  // const [actualSearchValue, setActualSearchValue] = useState('');
  const { searchResults, setSearchResults, searchTags, setSearchTags, setFromSearch } = useContext(SearchContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Busca - TudoPets.app';
  }, []);

  const handleSearchValueChange = (value) => {
    setSearchTags(value);
    if (value.length === 0) {
      setSearchResults([]);
      return;
    }
    setLoading(true);
    const tags = value.map(tag => tag.name).join(',')
    providersPathTo.list({ params: { t: tags } }).then((result) => {
      // setActualSearchValue(value);
      setLoading(false);
      setSearchResults(result.data);
    });
  };

  const handleCardClick = (providerId) => {
    setFromSearch(true)
    navigate(`/provider/${providerId}`);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>

      {/* Voltar e Título */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, alignSelf: 'stretch', minHeight: '31.2px', position: 'relative' }}>
        {/* Botão para Voltar */}
        {/* <Button onClick={() => window.history.back()} sx={{ color: 'text.primary', borderRadius: layoutIconButtonRadius }}>
          <ArrowBackRounded />
        </Button> */}

        {/* Título */}
        <Typography variant="pageTitle" sx={{ width: 'auto', transform: 'translateX(-50%)', position: 'absolute', left: '50%' }}>Busca</Typography>
      </Box>

      {/* Barra de Pesquisa po Tag */}
      <SearchField onChange={handleSearchValueChange} value={searchTags} />

      {/* Resultado da Pesquisa */}
      {loading ? (
        <Typography>Carregando...</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, alignSelf: 'stretch' }}>
          {/*{searchTags.length > 0 && (
            <>
              <Box display="flex" justifyContent="flex-start" alignItems="center" mt={2} flexWrap="wrap">
                <Typography sx={{ marginRight: 1 }}>Exibindo resultados para:</Typography>
                {searchTags.map((tag) => (
                  <Chip key={tag.id} label={tag.name} variant="outlined" sx={{ marginRight: 1 }} />
                ))}
              </Box>
            </>
          )}*/}
          {searchResults.map((provider) => (
            <ProviderCard key={provider.id} provider={provider} showProducts={true} categories={false} onCardClick={() => handleCardClick(provider.id)} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default Search;
